import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_ZON_Plantas_ListarPlantasDeEmpresa = async (CodigoCompania, CodigoEmpresa) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_ListarPlantasDeEmpresa"

    try {
        const resulData = await llamadaAPI_GET("ABM_ZON_Plantas/PorEmpresa/" +
            await TratamientoDeParametroParaURI(CodigoCompania) + "/" +
            await TratamientoDeParametroParaURI(CodigoEmpresa));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Listar = async () => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ZON_Plantas/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Leer = async (CodigoPlanta) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ZON_Plantas/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            await TratamientoDeParametroParaURI(CodigoPlanta));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_ZON_Plantas/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Modificar";

    try {
        await llamadaAPI_PUT("ABM_ZON_Plantas/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Generar_JSON = async (CodigoPlanta, CodigoEmpresa,
    Descripcion, IdPais, Calle, Numero, Piso, Depto, Email, Telefono, Logo, CodLocalExterno, CodRubroExterno, CodContratoExterno,
    RappiStoreId, RappiToken, CierreZetaManual, PuntoVentaConBotonTKA,
    PuntoVentaConBotonTKB, PuntoVentaConBotonTKM, PuntoVentaConBotonTKNCA,
    PuntoVentaConBotonTKNCB, PuntoVentaConBotonTKNCM, PuntoVentaConBotonFCA,
    PuntoVentaConBotonFCB, PuntoVentaConBotonFCC, PuntoVentaConBotonFCM,
    PuntoVentaConBotonPedidos, PuntoVentaConBotonCotizaciones, PuntoVentaConBotonCancelaTicket,
    PuntoVentaConBotonObservaciones, CierreZetaCiego, PuntoCompraConBotonTKA,
    PuntoCompraConBotonTKB, PuntoCompraConBotonTKM, PuntoCompraConBotonTKNCA,
    PuntoCompraConBotonTKNCB, PuntoCompraConBotonTKNCM, PuntoCompraConBotonFCA,
    PuntoCompraConBotonFCB, PuntoCompraConBotonFCC, PuntoCompraConBotonFCM,
    PuntoCompraConBotonPedidos, PuntoCompraConBotonCotizaciones, PuntoCompraConBotonObservaciones) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Generar_JSON";

    try {

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: CodigoEmpresa,
            CodigoPlanta: CodigoPlanta,
            IdEstado: 10,            
            Descripcion: Descripcion,
            IdPais: IdPais,
            Calle: Calle,
            Numero: Numero,
            Piso: Piso,
            Depto: Depto,
            Email: Email,
            Telefono: Telefono,
            Logo: Logo,
            CodLocalExterno: CodLocalExterno,
            CodRubroExterno: CodRubroExterno,
            CodContratoExterno: CodContratoExterno,
            RappiStoreId: RappiStoreId,
            RappiToken: RappiToken,
            CierreZetaManual: CierreZetaManual,
            PuntoVentaConBotonTKA: PuntoVentaConBotonTKA,
            PuntoVentaConBotonTKB: PuntoVentaConBotonTKB,
            PuntoVentaConBotonTKM: PuntoVentaConBotonTKM,
            PuntoVentaConBotonTKNCA: PuntoVentaConBotonTKNCA,
            PuntoVentaConBotonTKNCB: PuntoVentaConBotonTKNCB,
            PuntoVentaConBotonTKNCM: PuntoVentaConBotonTKNCM,
            PuntoVentaConBotonFCA: PuntoVentaConBotonFCA,
            PuntoVentaConBotonFCB: PuntoVentaConBotonFCB,
            PuntoVentaConBotonFCC: PuntoVentaConBotonFCC,
            PuntoVentaConBotonFCM: PuntoVentaConBotonFCM,
            PuntoVentaConBotonPedidos: PuntoVentaConBotonPedidos,
            PuntoVentaConBotonCotizaciones: PuntoVentaConBotonCotizaciones,
            PuntoVentaConBotonCancelaTicket: PuntoVentaConBotonCancelaTicket,
            PuntoVentaConBotonObservaciones: PuntoVentaConBotonObservaciones,
            CierreZetaCiego: CierreZetaCiego,
            PuntoCompraConBotonTKA: PuntoCompraConBotonTKA,
            PuntoCompraConBotonTKB: PuntoCompraConBotonTKB,
            PuntoCompraConBotonTKM: PuntoCompraConBotonTKM,
            PuntoCompraConBotonTKNCA: PuntoCompraConBotonTKNCA,
            PuntoCompraConBotonTKNCB: PuntoCompraConBotonTKNCB,
            PuntoCompraConBotonTKNCM: PuntoCompraConBotonTKNCM,
            PuntoCompraConBotonFCA: PuntoCompraConBotonFCA,
            PuntoCompraConBotonFCB: PuntoCompraConBotonFCB,
            PuntoCompraConBotonFCC: PuntoCompraConBotonFCC,
            PuntoCompraConBotonFCM: PuntoCompraConBotonFCM,
            PuntoCompraConBotonPedidos: PuntoCompraConBotonPedidos,
            PuntoCompraConBotonCotizaciones: PuntoCompraConBotonCotizaciones,
            PuntoCompraConBotonObservaciones: PuntoCompraConBotonObservaciones
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_ModificarLogo = async (CodigoPlanta, Logo) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_ModificarLogo";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: CodigoPlanta,            
            Logo: Logo
        };

        await llamadaAPI_PUT("ABM_ZON_Plantas/ModificarLogo", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_ModificarImagenAlternativa1 = async (CodigoPlanta, ImagenAlternativa1) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_ModificarImagenAlternativa1";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: CodigoPlanta,            
            ImagenAlternativa1: ImagenAlternativa1
        };

        await llamadaAPI_PUT("ABM_ZON_Plantas/ModificarImagenAlternativa1", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_ModificarImagenAlternativa2 = async (CodigoPlanta, ImagenAlternativa2) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_ModificarImagenAlternativa2";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: CodigoPlanta,            
            ImagenAlternativa2: ImagenAlternativa2
        };

        await llamadaAPI_PUT("ABM_ZON_Plantas/ModificarImagenAlternativa2", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_ModificarImagenAlternativa3 = async (CodigoPlanta, ImagenAlternativa3) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_ModificarImagenAlternativa3";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: CodigoPlanta,            
            ImagenAlternativa3: ImagenAlternativa3
        };

        await llamadaAPI_PUT("ABM_ZON_Plantas/ModificarImagenAlternativa3", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ZON_Plantas_Eliminar = async (CodigoPlanta) => {
    const NombreFuncion = "function_ABM_ZON_Plantas_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_ZON_Plantas/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            TratamientoDeParametroParaURI(CodigoPlanta));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};